import { buildInitialSubscriptionTargets } from "@common/subscription/SubscriptionPlan";
import type { SubscriptionPlan } from "@common/subscription/SubscriptionPlan";
import { normalizeTuneProjection, tuneProjectionInit } from "@common/talkn-config";
import type { TuneProjection, TuneProjectionKey } from "@common/talkn-config";

export const buildSubscriptionPlan = (
  option: Partial<TuneProjection> = {}
): SubscriptionPlan => {
  const normalizedOption = normalizeTuneProjection({
    ...tuneProjectionInit,
    ...option,
  });

  const streams = Object.entries(normalizedOption)
    .filter(([, enabled]) => Boolean(enabled))
    .map(([key]) => key as TuneProjectionKey);

  return {
    initial: buildInitialSubscriptionTargets(normalizedOption),
    streams,
  };
};

export default buildSubscriptionPlan;
